import useGetPaymentProviderStatusQuery from '@/api/queries/useGetPaymentProviderStatusQuery';
import { isBillingEnabledFor } from '@/config';
import {
  BillingDetailsEditPath,
  BillingHomePath,
  BillingPaymentMethodAddPath,
  BillingPaymentMethodListPath,
} from '@/modules/billing/paths';
import { RetailerSettingsPath } from '@/modules/retailer/paths';
import { default as BaseSettings, Section } from '@/modules/settings/pages/Settings';
import {
  CreditCardIcon,
  CurrencyDollarIcon,
  LanguageIcon,
  LockClosedIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import { Outlet } from 'react-router-dom';

const sections: (paymentProviderStatus?: boolean) => Section[] = (paymentProviderStatus) => {
  const retailerSections: Section[] = [
    {
      href: RetailerSettingsPath.profile,
      title: 'Profile',
      icon: UserIcon,
      children: [
        { href: RetailerSettingsPath.profile, title: 'Profile', icon: UserIcon },
        // {href: RetailerSettingsPath.notification, title: 'Notifications', icon: BellIcon},
        { href: RetailerSettingsPath.currency, title: 'Currency', icon: CurrencyDollarIcon },
        { href: RetailerSettingsPath.language, title: 'Language', icon: LanguageIcon },
        {
          href: RetailerSettingsPath.password,
          title: 'Change Password',
          icon: LockClosedIcon,
        },
      ],
    },
  ];

  if (paymentProviderStatus) {
    retailerSections.push({
      href: BillingHomePath,
      title: 'Billing',
      icon: CreditCardIcon,
      children: [
        {
          href: BillingHomePath,
          title: 'Billing',
          icon: CreditCardIcon,
          children: [
            {
              href: BillingDetailsEditPath,
              title: 'Edit Billing Details',
              icon: CreditCardIcon,
            },
          ],
        },
        {
          href: BillingPaymentMethodListPath,
          title: 'Payment Methods',
          icon: CreditCardIcon,
          children: [
            {
              href: BillingPaymentMethodAddPath,
              title: 'Add Payment Method',
              icon: CreditCardIcon,
            },
          ],
        },
      ],
    });
  }

  return retailerSections;
};

export const Settings = () => {
  const { status: paymentProviderStatus, isLoading } = useGetPaymentProviderStatusQuery();

  if (isLoading) {
    return null;
  }

  return (
    <BaseSettings
      sections={sections(paymentProviderStatus?.available && isBillingEnabledFor('retailer'))}
    >
      <Outlet />
    </BaseSettings>
  );
};

export default Settings;
